import type { Kernel } from "../sdk/kernel";
import { pi } from "./pi";
import { sir } from "./sir";
import { options } from "./options";
import { agritech } from "./agritech";

// Gallery registry. The four kernels selected in scoping (2026-06-12): π by sampling,
// SIR epidemic, options pricing (GBM), agritech yield sweep. All are writable as
// `verifiable: true` JS-function kernels (RFC-0008 acceptance tests). The transcendental
// ones (options, agritech) run on native Math today and join the fdlibm math shim at M3
// for cross-engine bitwise reproducibility.
export const kernels: Record<string, Kernel<any>> = {
  [pi.id]: pi,
  [sir.id]: sir,
  [options.id]: options,
  [agritech.id]: agritech,
};

export const galleryList = Object.values(kernels).map((k) => ({
  id: k.id,
  label: k.label,
  blurb: k.blurb ?? "",
  resultUnit: k.resultUnit ?? "result",
  defaultN: k.defaultN ?? 1_000_000,
  verifiable: k.verifiable,
  params: k.params ?? [],
}));

/** Look up a kernel's gallery metadata by id (UI helper). */
export function kernelMeta(id: string) {
  return galleryList.find((k) => k.id === id);
}
